import React from "react";
import styles from "./Row.module.sass";
import cn from "classnames";
import Checkbox from "../../../../components/Checkbox";
import LetterAvatar from "../../../../components/LetterAvatar";
import Icon from "../../../../components/Icon";
import { useNavigate } from "react-router-dom";
import { getFolderById } from "../../../../services/folder.service";

const Row = ({
    item,
    activeTable,
    setActiveTable,
    activeId,
    setActiveId,
    onClick,
    progressionIcon,
    selected,
    onSelect
}) => {
    const navigate = useNavigate();

    const handleRowClick = async () => {
        if (onClick) {
            onClick(item.id);
        }

        try {
            // Récupérer les données complètes du dossier avant de naviguer
            const folderData = await getFolderById(item.id);
            navigate(`/admin/folders/${item.id}`, { state: { folder: folderData } });
        } catch (error) {
            console.error('Erreur lors de la récupération des données du dossier:', error);
            // Naviguer quand même avec les données partielles
            navigate(`/admin/folders/${item.id}`, { state: { folder: item } });
        }
    };

    // Extraire les informations de l'étudiant
    const student = item.expand?.student_id;
    const company = item.expand?.company_id;
    const formation = item.expand?.formation_id;
    const promotion = item.expand?.promotion_id;
    const contract = item.expand?.contract_id;
    const opco = item.expand?.opco_id;

    // Déterminer le statut du dossier
    const getStatusInfo = () => {
        if (item.status === 'brouillon') {
            return { label: 'Brouillon', className: 'status-yellow' };
        } else if (item.status === 'complet') {
            return { label: 'Complet', className: 'status-green' };
        } else if (item.status === 'en_attente') {
            return { label: 'En attente', className: 'status-blue' };
        } else if (item.status === 'bloque') {
            return { label: 'Bloqué', className: 'status-red' };
        } else {
            return { label: item.status || 'Non défini', className: 'status-gray' };
        }
    };

    const statusInfo = getStatusInfo();

    const handleCheckboxChange = (e) => {
        e.stopPropagation(); // Empêcher la propagation pour éviter de déclencher handleRowClick
        onSelect && onSelect(item.id);
    };

    return (
        <>
            <div className={styles.row} onClick={handleRowClick} style={{ cursor: 'pointer' }}>
                <div className={styles.col} onClick={(e) => e.stopPropagation()}>
                    <Checkbox
                        className={styles.checkbox}
                        checked={selected}
                        onChange={handleCheckboxChange}
                    />
                </div>

                <div className={styles.col}>
                    <div className={styles.item}>
                        <div className={styles.avatar}>
                            <LetterAvatar
                                firstName={student?.first_name || ''}
                                lastName={student?.last_name || ''}
                                size={48}
                            />
                        </div>
                        <div className={styles.details}>
                            <div className={styles.user}>
                                {student ? `${student.first_name || ''} ${student.last_name || ''}` : 'N/A'}
                            </div>
                            <div className={styles.login}>
                                {formation?.exact_title_of_qualification || 'Aucune formation'}
                            </div>
                            <div className={styles.email}>
                                {student?.email || 'N/A'}
                            </div>
                        </div>
                    </div>
                </div>
                
                <div className={styles.col}>
                    <div className={styles.email}>{promotion?.title_promotion || 'N/A'}</div>
                </div>
                
                <div className={styles.col}>
                    <div className={cn('status-type', 'status-blue-dark')}>
                        {company?.name || 'N/A'}
                    </div>
                </div>

                <div className={styles.col}>
                    <div className={cn('status-type', statusInfo.className)}>
                        {opco?.name}
                    </div>
                </div>
                       
            </div>
        </>
    );
};

export default Row;
